import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const FilterOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function FilterOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M21.934 4.04H1.967v2h19.967v-2ZM17.401 11.04H6.51v2h10.892v-2Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M21.934 4.04H1.967v2h19.967v-2Zm-4.533 7H6.51v2h10.892v-2Z" />
          <path d="M9.045 18.04h5.83v2h-5.83v-2Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default FilterOutlined;